import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'OzonEventsAPI';

export const ozonEventsAPI = {
  getEvents: async (params = {}, showNotification = false) => {
    try {
      const response = await api.get('/ozon-events', { params });
      return handleSuccessResponse(response, MODULE_NAME, 'Получение событий Ozon', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении событий Ozon', showNotification);
    }
  },
};
